import Popover from './Popover.vue';
import PopoverDirective from './directive';

export default function install(Vue) {
  // IE11 fix for using svg elements for popover activators.
  if (typeof SVGElement.prototype.contains === 'undefined') {
    SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
  }

  Vue.component(Popover.name, Popover);
  Vue.directive('popover', PopoverDirective);
}
